import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StammkundeService } from '../../../Services/stammkunde.service';
import { StammkundeWorker } from '../../../Models/stammkunde.model';

export interface WorkerFormData {
  customerId: number;
  worker?: StammkundeWorker;
}

/** Popup zum Anlegen/Bearbeiten eines Arbeiters (ohne App-Login). */
@Component({
  selector: 'app-worker-form',
  templateUrl: './worker-form.component.html',
  styleUrls: ['./worker-form.component.css', '../stammkunden-theme.css']
})
export class WorkerFormComponent {
  isEdit: boolean;
  name = '';
  phone = '';
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<WorkerFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkerFormData,
    private stammkundeService: StammkundeService,
    private snackBar: MatSnackBar
  ) {
    this.isEdit = !!data.worker;
    if (data.worker) {
      this.name = data.worker.name;
      this.phone = data.worker.phone ?? '';
    }
  }

  save(): void {
    if (this.saving) return; // Enter-Taste kann sonst doppelt auslösen
    const name = this.name.trim();
    if (!name) return;
    this.saving = true;

    const payload = { name, phone: this.phone.trim() || undefined };
    const request$ = this.isEdit
      ? this.stammkundeService.updateWorker(this.data.customerId, this.data.worker!.id, payload)
      : this.stammkundeService.addWorker(this.data.customerId, payload);

    request$.subscribe({
      next: worker => {
        this.saving = false;
        this.dialogRef.close(worker);
      },
      error: err => {
        this.saving = false;
        const message = err?.error?.message || 'Fehler beim Speichern des Arbeiters.';
        this.snackBar.open(message, 'OK', { duration: 5000 });
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
